export default "__VITE_ASSET__BNfCZH2g__"